module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titleCalendarContainer"
  }, [(_vm.getImportSuccess) ? _c('div', {
    staticClass: "importSuccess"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeSuccess()
      }
    }
  }, [_vm._v("X")]), _vm._v(_vm._s(_vm.IMPORT_SUCCESS))]) : _vm._e(), _c('div', {
    staticClass: "titleCalendar"
  }, [_c('div', {
    staticClass: "menuCalendar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "titleYear"
  }, [_c('h2', [_vm._v("My calendar " + _vm._s(_vm.getSelectedYear)), _c('span', {
    ref: "arrow",
    on: {
      "click": function($event) {
        return _vm.showYear()
      }
    }
  }, [_vm._v(" ")])]), _c('ul', {
    ref: "dropdown",
    staticClass: "yearList",
    class: {
      active: _vm.editYear
    }
  }, _vm._l((_vm.yearList), function(year) {
    return _c('li', {
      class: {
        current: year === _vm.getSelectedYear
      },
      on: {
        "click": function($event) {
          return _vm.changeYear(year)
        }
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)]), (_vm.showBookedHolidays) ? _c('div', {
    staticClass: "titleGoogleCalendar"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.kaleidersCalendar
    }
  }, [_vm._v("Google calendar")])]) : _vm._e()]), _c('ul', {
    staticClass: "legend"
  }, [(_vm.showBookedHolidays) ? _c('li', {
    staticClass: "booked"
  }, [_c('span'), _vm._v(_vm._s(_vm.BOOKED_HOLIDAY))]) : _vm._e(), _c('li', {
    staticClass: "public"
  }, [_c('span'), _vm._v(_vm._s(_vm.PUBLIC_HOLIDAY))])])]), (!_vm.showBookedHolidays) ? _c('button', {
    staticClass: "importCalendar",
    on: {
      "click": function($event) {
        return _vm.importCalendar()
      }
    }
  }, [_vm._v("Import calendar")]) : _vm._e(), (_vm.showBookedHolidays) ? _c('div', {
    staticClass: "calendarUserData",
    class: {
      noDays: _vm.getMe.remainingDays < 1,
      hasCarryOverDays: _vm.getMe.hasCarryOverDays
    }
  }, [_c('div', {
    staticClass: "days"
  }, [_vm._v(_vm._s(_vm.getMe.remainingDays))]), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.AVAILABLE_DAYS))]), _vm._l((_vm.allYearsNum), function(year) {
    return _c('span', {
      staticClass: "daysPerYear"
    }, [_vm._v(_vm._s(year.year) + " " + _vm._s(year.info) + " (" + _vm._s(year.num) + ")")])
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c76a24a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/MenuCalendar/MenuCalendar.pug
// module id = 188
// module chunks = 1